import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import API from "../../../shared/core/services/user-profile-service";
import { TokenResponse, HttpError } from "../../../shared/core/models";
import { get } from "lodash";
const initialState = {
  data: {},
  isLoading: false,
  error: null as string | null,
};

/**
 * Thunks Actions
 */
const getProfile = createAsyncThunk<any, any, any>(
  "profile/get",
  async (params: any, thunkAPI) => {
    try {
      thunkAPI.dispatch(starLoading());
      const result: any = await API.loadUserProfile();
      
      // Check if result contains an error
      if (result && typeof result === 'object' && 'error' in result) {
        // Reject with the error message instead of returning Error object
        return thunkAPI.rejectWithValue({
          message: result.error,
          status: result.status
        });
      }
      
      // If successful, dispatch success action
      thunkAPI.dispatch(onSuccess(get(result, "body", {})));
      thunkAPI.dispatch(endLoading());
      return result;
    } catch (error) {
      thunkAPI.dispatch(endLoading());
      return thunkAPI.rejectWithValue({
        message: error instanceof Error ? error.message : "Unknown error occurred",
        name: error instanceof Error ? error.name : "Error"
      });
    }
  }
);

/**
 * Reducers
 */
const profileReducer = createSlice({
  name: "profile",
  initialState: initialState,
  reducers: {
    onSuccess(state, response) {
      state.data = response.payload;
      console.log("state.data", state.data);
    },
    starLoading(state) {
      state.isLoading = true;
    },
    endLoading(state) {
      state.isLoading = false;
    },
    setProfileData(state, response) {
      state.data = response.payload.body;
    },
    logout(state) {
      state.data = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getProfile.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.isLoading = false;
        state.error = null;
      }
    );
    builder.addCase(getProfile.rejected, (state: any, action) => {
      state.isLoading = false;
      state.error = action.payload || action.error?.message || "An error occurred";
    });
  },
});

/*Actions export*/
const { starLoading, endLoading, onSuccess, setProfileData ,logout} = profileReducer.actions;
export { starLoading, endLoading, onSuccess, getProfile, setProfileData ,logout};
/*Reducer export*/
export default profileReducer;
